export default function addNotification(notification) {
    return {
        type: addNotification.type,
        payload: notification,
    };
}

addNotification.type = 'ADD_NOTIFICATION';
